// src/components/PrivacyPolicy.js
import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 20px;
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  color: #5c5c5c;
  font-family: 'aria-label', sans-serif;
`;

const EmailLink = styled.a`
  color: #4b6353; /* This controls the color of the email link */
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const PrivacyPolicy = () => (
  <PageContainer>
    <h1>Privacy Policy</h1>
    <p>
      At Color Palette Tool, we are committed to protecting your privacy. This Privacy Policy outlines
      how we collect, use, and protect your information when you use our services.
    </p>
    <h2>Information We Collect</h2>
    <p>
      We may collect the following information when you use our website:
    </p>
    <ul>
      <li>Personal information you provide to us, such as your name, email address, and contact details.</li>
      <li>Usage data, such as the pages you visit, the time spent on those pages, and other interaction data.</li>
      <li>Technical data, such as your IP address, browser type, and operating system.</li>
    </ul>
    <h2>How We Use Your Information</h2>
    <p>
      We use your information for the following purposes:
    </p>
    <ul>
      <li>To provide and improve our services.</li>
      <li>To respond to your inquiries and provide customer support.</li>
      <li>To send you updates, newsletters, and marketing communications.</li>
      <li>To analyze website usage and improve our website.</li>
    </ul>
    <h2>How We Protect Your Information</h2>
    <p>
      We take appropriate security measures to protect your information from unauthorized access,
      disclosure, alteration, or destruction. However, no internet transmission is completely secure,
      and we cannot guarantee the absolute security of your data.
    </p>
    <h2>Third-Party Services</h2>
    <p>
      We may use third-party services to help us operate our website and provide our services. These
      third parties may have access to your information as necessary to perform their functions, but
      they are obligated not to disclose or use it for any other purpose.
    </p>
    <h2>Your Rights</h2>
    <p>
  You have the right to access, correct, or delete your personal information. You can also opt-out
  of receiving marketing communications from us. To exercise these rights, please contact us at
  <span> </span>
  <EmailLink  href="mailto:thelalabmy@gmail.com" target="_blank" rel="noopener noreferrer">thelalabmy@gmail.com</EmailLink >
</p>


    <h2>Changes to This Privacy Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of any changes by posting
      the new Privacy Policy on our website. You are advised to review this Privacy Policy periodically
      for any changes.
    </p>
    <p>
      If you have any questions about this Privacy Policy, please contact us at <EmailLink  href="mailto:thelalabmy@gmail.com" target="_blank" rel="noopener noreferrer">thelalabmy@gmail.com</EmailLink >  
    </p>
  </PageContainer>
);

export default PrivacyPolicy;
